module.exports = require("node-fetch");


//////////////////
// WEBPACK FOOTER
// external "node-fetch"
// module id = 34
// module chunks = 0